import * as React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  width?: string;
  height?: string;
  color?: string;
}

const BackButtonIcon = ({ width, height, color }: Props | undefined) => {
  return (
    <svg
      className={styles.backButtonIcon}
      width={width || '38px'}
      height={height || '38px'}
      viewBox="0 0 38 38"
      version="1.1"
    >
      <g id="Style-Guide" stroke="none" strokeWidth="1" fill={color || 'none'} fillRule="evenodd">
        <g transform="translate(-46.000000, -4329.000000)" id="Group">
          <g transform="translate(47.000000, 4330.000000)">
            <circle id="Oval" stroke="#006DA8" fill="#FFFFFF" cx="18" cy="18" r="18" />
            <polygon
              id="Imported-Layers-13"
              fill="#006DA8"
              points="12.50275 17.0625 20.532625 9.032625 18.5 7 7 18.5 18.5 30 20.532625 27.967375 12.50275 19.9375 30 19.9375 30 17.0625"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BackButtonIcon;
